import { EnvironmentProviders, Provider, makeEnvironmentProviders } from "@angular/core";
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslationService } from "./translation.service";
import { TranslationLoader } from "./loaders/TranslationLoader";
import { TranslationHttpLoader } from "./loaders/TranslationHttpLoader";
import { of } from "rxjs";

const defaultLang = JSON.parse(localStorage.getItem("language") ?? '"en"');
export function provideTranslation(): (Provider | EnvironmentProviders)[] {
  return [
    makeEnvironmentProviders([
      TranslationService,
      {
        provide: TranslationLoader,
        useExisting: TranslateLoader,
      },
    ]),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationHttpLoader,
        deps: [HttpClient],
      },
      defaultLanguage: defaultLang,
      extend: true,
      isolate: false,
    }),
  ];
}

export function initializeTranslation(translationService: TranslationService) {
  const savedLang = translationService.getUserLang();
  if (savedLang) {
    return translationService.use(savedLang);
  }
  return of(null);
}
